import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconOldJoystick: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="old-joystick, gamepad, gaming, control"><path d="M12 9.25V14.75" stroke="currentColor" strokeWidth="1.5"/><path d="M17.25 11V15" stroke="currentColor" strokeWidth="1.5"/><path d="M20.25 14.75H3.75V20.25H20.25V14.75Z" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="6.5" r="2.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconOldJoystick;
